import React from 'react';

function Security() {
  return <div>Security</div>;
}

export default Security;
